// imports
import Component from 'minsky-kit/js/components/Component';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// private statics

// class definition

export default class InviewManager extends Component {
    // constructor
    constructor (args = {}, objectName = 'InviewManager') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // register gsp plugins
        gsap.registerPlugin(ScrollTrigger);

        // set properties
        this.$el = args.$el;

        // animation
         const tl = gsap.timeline();

        tl.fromTo(
            this.$el,
            {
                y:       25,
                opacity: 0,
            },
            {
                y:        0,
                opacity:  1,
                duration: 0.5,
            },
        );

        tl.set(this.$el, {
          clearProps: 'all'
        });

        // scrolltrigger
        ScrollTrigger.create({
            markers:   false,
            trigger:   this.$el,
            start:     `top ${(window.innerHeight / 8) * 7}`,
            animation: tl,
            // markers: true
        });
    }

    // methods
    destroy () {
        // super destroy
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
